__webpack_require__.p = "/mslegacy/minesweeper-5/";